<template>
  <div>
    <div
      :class="{ 'disabled': disabled, 'is-boxed': isBoxed }"
      class="file has-name is-fullwidth is-primary"
    >
      <label class="file-label">
        <input
          v-if="uploadReady"
          ref="file"
          class="file-input"
          type="file"
          :aria-placeholder="placeholder"
          :placeholder="placeholder"
          :disabled="disabled"
          :name="name"
          @change="onFileChange"
        >
        <span class="file-cta">
          <span class="file-icon">
            <i
              class="fas fa-upload upload-button"
              aria-hidden="true"
            />
          </span>
          <span
            class="file-label"
            v-text="$attrs.title || 'Choose file'"
          />
        </span>
        <span class="file-name">
          {{ !value ? placeholder : value.name }}
        </span>
      </label>
    </div>
    <div class="info">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isBoxed: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [ Object, File ],
      required: false,
      default: null,
    },
    disabled: {
      type: [ String, Boolean ],
      default: false,
    },
    placeholder:  {
      type: String,
      default: 'No file chosen',
    },
  },
  data() {
    return {
      uploadReady: true,
    };
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.clear();
      }
    },
  },
  methods: {
    clear () {
      this.$refs.file.value = '';
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.$emit('input', files[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
  .is-boxed {
    .file-name, .file-cta {
      text-align: center;
    }
  }
  .simple {
    .file-cta {
      .file-icon {
        width: auto;
        margin: 0;
      }
      .file-label {
        display: none;
      }
    }
  }
  .disabled {
    * {
      cursor: not-allowed !important;
    }
  }
  .info {
    p, small {
      line-height: 115%;
    }
  }
  .file-name {
    background-color: #fff;
  }
</style>